module.exports = __webpack_public_path__ + "img/icon-setting.05930d6b.svg";